"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSearchProvider = exports.SearchProvider = exports.SearchContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const index_1 = require("../../service/index");
const typedi_1 = __importDefault(require("typedi"));
exports.SearchContext = (0, react_1.createContext)(null);
function SearchProvider({ children }) {
    const library = typedi_1.default.get(index_1.Search);
    return ((0, jsx_runtime_1.jsx)(exports.SearchContext.Provider, { value: library, children: children }));
}
exports.SearchProvider = SearchProvider;
function withSearchProvider(Component) {
    return function WrappedComponent(props) {
        return ((0, jsx_runtime_1.jsx)(SearchProvider, { children: (0, jsx_runtime_1.jsx)(Component, Object.assign({}, props)) }));
    };
}
exports.withSearchProvider = withSearchProvider;
